import { Reading } from "./api";

function evaluateTemperature(temperature: number) {
  if (temperature > 24) {
    return "unpleasantly hot";
  }
  if (temperature > 15) {
    return "pleasant";
  }
  if (temperature > 10) {
    return "cold";
  }
  if (temperature > 0) {
    return "probably dangerously cold";
  }
  return "a sign very bad things are happening to my flat and body";
}


export default function AtmosphericData({ reading }: { reading: Reading | undefined }) {
  if (!reading || !reading.temperature) {
    return (
    <div>
      <p>No data :(</p>
    </div>
    )
  }
  return (
    <div>
      <p>The current temperature is {reading.temperature}°C, which is {evaluateTemperature(reading.temperature)}</p>
      <p>Humidity: {reading.humidity}%</p>
      <p>Pressure: {reading.pressure} hPa</p>
    </div>
  );
}
